module.exports = __webpack_public_path__ + "img/mark.7eb19ba2.jpg";